window.addEventListener("load",function(){
  let body_width = document.documentElement.clientWidth
  $(".moq_block_button").click(function(){
    if ($(this).hasClass("active"))  return
    $(".moq_block_button").removeClass("active")
    $(this).addClass("active")
    if ($(this).hasClass("other_moq")) {
      $(".price--new-container").html($(".price--new-container").data("disprice"))
       $(".custom-variant-item-price").each(function(i){
         $(this).html($(this).data("disprice"))
       });
    }else{
      $(".price--new-container").html($(".price--new-container").data("price"))
          $(".custom-variant-item-price").each(function(i){
         $(this).html($(this).data("price"))
       });
    }
  })
  $(".mobile-facets__open-wrapper_new").click(function() {
    if($(this).hasClass("mobile_facet_open")){
    $(this).siblings(".facets_mobile").hide()
      $(this).removeClass("mobile_facet_open")
    }else{
      $(this).siblings(".facets_mobile").show()
      $(this).addClass("mobile_facet_open")
    }
  })
  // $("input[name='new_price']").change(function() {
  //   var new_price_value = $(this).val()
  //   console.log(new_price_value)
  //   let minValue =new_price_value.split("-")[0]
  //   let maxValue = new_price_value.split("-")[1]
  //   $(".field__input_min_pice").val(minValue)
  //   $(".field__input_max_pice").val(maxValue)
  // })
  //   $("input[name='new_price_m']").change(function() {
  //   var new_price_value = $(this).val()
  //   let minValue =new_price_value.split("-")[0]
  //   let maxValue = new_price_value.split("-")[1]
  //   $(".field__input_min_pice_m").val(minValue)
  //   $(".field__input_max_pice_m").val(maxValue)
  // })
  $(".menu-drawer__navigation-container-top-close").click(function(){
    $(".header__icon--menu").click()
  })
  $(".mobile_mega_menu").click(function() {
    $(this).siblings(".mobile_mega_menu_content").addClass("active")
  })
  $(".js_close_mobile_mega_menu_content").click(function() {
    $(this).parents(".mobile_mega_menu_content").removeClass("active")
  })
  $(".mobile_mega_menu_content_top_close").click(function() {
    $(this).parents(".mobile_mega_menu_content").removeClass("active")
    $(".header__icon--menu").click()
  })
  $(".index-section-swiper-item-video_mask").click(function() {
    let video = $(this).siblings("video")[0]
    if ($(this).hasClass("hide-mask")) {
      $(this).hide()
    }
     if (video.paused) {
           video.play();
           $(this).find("img").fadeOut()
          } else {
              video.pause();
           $(this).find("img").fadeIn()
          }
    })
    $(".faq_new_content_title").click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active")
      $(this).siblings(".faq_new_content_content").slideUp()
    }else{
       $(this).addClass("active")
      $(this).siblings(".faq_new_content_content").slideDown()
    }
  })
  if (body_width < 990) {
    $(".coll_des_more").click(function() {
      $(this).siblings(".coll_description").css({"height":"auto"})
      $(this).hide()
    })
      $(".footer-block__heading_menu_new").click(function() {
    if ($(this).parent().find(".footer-block__heading_menu_content_new").css("display") == "none") {
    $(this).parent().find(".footer-block__heading_menu_content_new").slideDown()
      
    }else{
    $(this).parent().find(".footer-block__heading_menu_content_new").slideUp()
    }
  })
  }
  $(".mega_new_list_item").click(function() {
    let index = $(this).data("index")
    if (!$(this).hasClass("active")) {
       $(".mega_new_list_item").removeClass("active")
       $(this).addClass("active")
      $(".mega_new_content").removeClass("active")
      $(`.mega_new_content[data-index='${index}']`).addClass("active")
    }
    
  })
   $(".color_card_item").click(function() {
    if (!$(this).hasClass("active")) {
      let id = $(this).attr("data-control")
      $(".color_card_item").removeClass("active")
      $(this).addClass("active")
      $(".color_card_section").removeClass("color_card_content_active")
      $(`#color_card_${id}`).addClass("color_card_content_active")
    }
  })
  $(".product_custom_logo_size_shape_select").change(function() {
    let imageObj = [
      {
        "name":"Square",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/LOGO_29d8c49a-02f3-424c-888e-c33a8b6bdf5c.png?v=1731463525",
        "valueList":["1 Inch * 1 Inch","1.2 Inch * 1.2 Inch","1.8 Inch * 1.8 Inch","2 Inch * 2 Inch"]
      },
       {
        "name":"Rectangle",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/7_3_-LOGO.png?v=1731463525",
        "valueList":["2 Inch * 0.6 Inch","2.4 Inch * 0.6 Inch","3.5 Inch * 1.6 Inch","3.5 Inch * 1.2 Inch","3.5 Inch * 1.8 Inch","4 Inch * 1.2 Inch","3.1 Inch* 0.8 Inch","3.9 Inch * 1.4 Inch","3.5 Inch * 1.2 Inch"]
      },
       {
        "name":"Triangle",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/LOGO_e53014d9-b025-4baa-a893-2ee9559b57a5.png?v=1731463525",
        "valueList":["0.78 Inch * 0.78 Inch","1.18 Inch * 1.18 Inch"]
      },
       {
        "name":"Rotundity",
        "image":"https://cdn.shopify.com/s/files/1/0550/5207/5070/files/LOGO_468e4e55-2022-4582-b14f-110a66dd1cba.png?v=1731463525",
        "valueList":["0.8 Inch * 0.8 Inch","1.2 Inch * 1.2 Inch","1.5 Inch * 1.5 Inch"]
      }
    ]
    let val = $(this).val()
    for (let item of imageObj) {
      if (val == item.name) {
        $(this).siblings(".product_custom_logo_size_shape_image").find("img").attr("src",item.image)
        $(".product_custom_logo_size_select").empty()
        $.each(item.valueList, function(index, option) {
           $(".product_custom_logo_size_select").append(new Option(option, option));
        });
      }
    }
  })
  $(".product_custom_logo_radio").click(function() {
    if (!$(this).hasClass("active")) {
      const custom_logo_block = document.querySelector(".custom_logo_block")
      let index = $(this).index()
      $(this).siblings().removeClass("active")
      $(this).addClass("active")
      if (index == 0) {
        $(".product_custom_logo_content").addClass("active")
        if(custom_logo_block){
          document.querySelector("custom-variant").setAttribute("data-custom-logo-limit","4")
        }
      }else{
        $(".product_custom_logo_content").removeClass("active")
          if(custom_logo_block){
          document.querySelector("custom-variant").setAttribute("data-custom-logo-limit","0")
        }
      }
    }
  })
  $("input[name='custom_logo_position']").change(function() {
     const selectedCount = $("input[name='custom_logo_position']:checked").length;
      const total_count = $(".product_custom_total").html() * 1
      const logoMaterialPrice =  $('input[name="product_custom_logoMaterial"]:checked').data("price") * 1 * total_count * selectedCount;
      $(".product_custom_material_total").html(total_count * selectedCount)
      $(".product_custom_total_price").html(`$${(logoMaterialPrice / 100).toFixed(2)}`)
  })
   $("input[name='product_custom_logoMaterial']").change(function() {
     const selectedCount = $("input[name='custom_logo_position']:checked").length;
      const total_count = $(".product_custom_total").html() * 1
      const logoMaterialPrice =  $('input[name="product_custom_logoMaterial"]:checked').data("price") * 1 * total_count * selectedCount;
      $(".product_custom_material_total").html(total_count * selectedCount)
      $(".product_custom_total_price").html(`$${(logoMaterialPrice / 100).toFixed(2)}`)
  })
$(".product_custom_logoMaterial_example_media").click(function () {
  $("body, html").addClass("popshow");
  $(".product_custom_example_media_pop").fadeIn();

  let src = $(this).attr("data-media");

  if ($(this).hasClass("product_custom_logoMaterial_example_image")) {
      $(".product_custom_example_media_pop_content").html(`<img src="${src}" alt="">`);
    } else if ($(this).hasClass("product_custom_logoMaterial_example_video")) {
      $(".product_custom_example_media_pop_content").html(`
        <video src="${src}" controls autoplay></video>
      `);
    }
  });
  $(".product_custom_example_media_pop").click(function (e) {
    if ($(e.target).is(".product_custom_example_media_pop")) {
      $(this).fadeOut();
      $("body, html").removeClass("popshow");
      $(".product_custom_example_media_pop_content").empty();
    }
  });
})
function change_newPrice(e) {
    var new_price_value = $(e).val()
    let minValue =new_price_value.split("-")[0]
    let maxValue = new_price_value.split("-")[1]
    $(".field__input_min_pice").val(minValue)
    $(".field__input_max_pice").val(maxValue)
}
function change_newPriceM(e) {
    var new_price_value = $(e).val()
    let minValue =new_price_value.split("-")[0]
    let maxValue = new_price_value.split("-")[1]
    $(".field__input_min_pice").val(minValue)
    $(".field__input_max_pice").val(maxValue)
}


class customCardProductColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.mediaWrappers = this.querySelectorAll(".custom-color-media-wrapper")
    this.swatchs = this.querySelectorAll(".custom-card-product-color-item")
    this.swatchs.forEach(element => {
      console.log(element);
      element.addEventListener("click",this.buttonClick.bind(this))
    });
  }
  buttonClick(e) {
      const current = e.currentTarget;
      const color = current.dataset.color;
      this.swatchs.forEach(el => el.classList.remove("active"));
      current.classList.add("active");
       this.mediaWrappers.forEach(wrapper => {
        if (wrapper.dataset.color === color) {
          wrapper.classList.add("active");
        } else {
          wrapper.classList.remove("active");
        }
      });
  }
}

customElements.define('custom-card-product-color-swatch', customCardProductColorSwatch);